import {
    Footage,
    TimelineInfo,
    Timeline,
    Folder,
    Clip,
    UploadTimelineInfo,
} from "../../models/Timeline";
import TimelineEvents from "../events/TimelineEvents";

// 未編集のフッテージ一覧取得
export const GetUneditedFootages = () =>
    ({
        type: TimelineEvents.GetUneditedFootagesStarted,
    } as const);

export const GetUneditedFootagesComplete = (footage: Footage[]) =>
    ({
        type: TimelineEvents.GetUneditedFootagesComplete,
        footage,
    } as const);

// タイムラインリスト取得
export const GetTimelines = (statusList: string[]) =>
    ({
        type: TimelineEvents.GetTimelinesStarted,
        statusList,
    } as const);

export const GetTimelinesComplete = (timeline: TimelineInfo[]) =>
    ({
        type: TimelineEvents.GetTimelinesComplete,
        timeline,
    } as const);

// 直近のフッテージ取得
export const GetRecentFootages = (userId: number, days: number) =>
    ({
        type: TimelineEvents.GetRecentFootagesStarted,
        userId,
        days,
    } as const);

export const GetRecentFootagesComplete = (footage: Footage[]) =>
    ({
        type: TimelineEvents.GetRecentFootagesComplete,
        footage,
    } as const);

// タイムライン作成
export const CreateTimeline = (userId: number, timeLineName: string) =>
    ({
        type: TimelineEvents.CreateTimelineStarted,
        userId,
        timeLineName,
    } as const);

export const CreateTimelineComplete = (timeline: Timeline) =>
    ({
        type: TimelineEvents.CreateTimelineComplete,
        timeline,
    } as const);

export const CreateTimelineFailed = (error: string, timeline: TimelineInfo[]) =>
    ({
        type: TimelineEvents.CreateTimelineFailed,
        error,
        timeline,
    } as const);

// タイムライン削除
export const DeleteTimeline = (userId: number, timelineId: number) =>
    ({
        type: TimelineEvents.DeleteTimelineStarted,
        userId,
        timelineId,
    } as const);

export const DeleteTimelineComplete = (timelineId: number) =>
    ({
        type: TimelineEvents.DeleteTimelineComplete,
        timelineId,
    } as const);

// タイムライン取得
export const getTimeline = (id: number) =>
    ({
        type: TimelineEvents.GetTimelineStarted,
        id,
    } as const);

// タイムライン取得完了
export const GetTimelineComplete = (result: Timeline) =>
    ({
        type: TimelineEvents.GetTimelineComplete,
        result,
    } as const);

// タイムライン取得エラー
export const GetTimelineFailed = (result: any) =>
    ({
        type: TimelineEvents.GetTimelineFailed,
        result,
    } as const);

// タイムライン再生開始
export const PlayTimeline = () =>
    ({
        type: TimelineEvents.PlayTimeline,
    } as const);

// タイムライン再生一時停止
export const PauseTimeline = () =>
    ({
        type: TimelineEvents.PauseTimeline,
    } as const);

// タイムライン再生終了
export const FinishTimeline = () =>
    ({
        type: TimelineEvents.FinishTimeline,
    } as const);

// タイムラインのリプレイ
export const ReplayTimeline = () =>
    ({
        type: TimelineEvents.ReplayTimeline,
    } as const);

// タイムラインのリセット
export const ResetTimeline = () =>
    ({
        type: TimelineEvents.ResetTimeline,
    } as const);

// タイムライン時間更新
export const UpdateTimelinePlayInfo = (
    currentTime?: number,
    totalTime?: number | null,
    sourceLength?: number | null,
    clipTimes?: number[] | null,
    isFinished?: boolean
) =>
    ({
        type: TimelineEvents.UpdateTimelinePlayInfo,
        currentTime,
        totalTime,
        sourceLength,
        clipTimes,
        isFinished,
    } as const);

// タイムライン再生中のクリップINDEXを更新
export const UpdateTimelineSourceIndex = (sourceIndex: number) =>
    ({
        type: TimelineEvents.UpdateTimelineSourceIndex,
        sourceIndex,
    } as const);

// タイムラインの編集ショートカットキー番号を更新
export const UpdateTimelineShootCutKeyId = (shootCutKeyId: number) =>
    ({
        type: TimelineEvents.UpdateTimelineShootCutKeyId,
        shootCutKeyId,
    } as const);

// タイムラインのkeyboardでvideo再生をコントロールするかどうか
export const SetIsHandleKeyboard = (flag: boolean) =>
    ({
        type: TimelineEvents.SetIsHandleKeyboard,
        flag,
    } as const);

// タイムラインをcineonhubにアップロード
export const UploadTimeline = (timeline: UploadTimelineInfo) =>
    ({
        type: TimelineEvents.UploadTimelineStarted,
        timeline,
    } as const);

export const UploadTimelineComplete = (timeline: UploadTimelineInfo) =>
    ({
        type: TimelineEvents.UploadTimelineComplete,
        timeline,
    } as const);

export const UploadTimelineFailed = () =>
    ({
        type: TimelineEvents.UploadTimelineFailed,
    } as const);

// フッテージリスト取得
export const getFootageList = (id: number) =>
    ({
        type: TimelineEvents.GetFootageListStarted,
        id,
    } as const);

// フッテージリスト取得取得完了
export const getFootageListComplete = (result: Footage[]) =>
    ({
        type: TimelineEvents.GetFootageListComplete,
        result,
    } as const);

// フッテージ動画取得
export const getFootageVideo = (id: number) =>
    ({
        type: TimelineEvents.GetFootageVideoStarted,
        id,
    } as const);

//フッテージ動画取得完了
export const getFootageVideoComplete = (result: any, id: number) =>
    ({
        type: TimelineEvents.GetFootageVideoComplete,
        result,
        id,
    } as const);

//サムネイル取得
export const getThumbnail = (id: number) =>
    ({
        type: TimelineEvents.GetThumbnailStarted,
        id,
    } as const);

//サムネイル取得完了
export const getThumbnailComplete = (result: any) =>
    ({
        type: TimelineEvents.GetThumbnailComplete,
        result,
    } as const);

//利用可能ディレクトリリスト取得
export const getUsableDirList = (id: number) =>
    ({
        type: TimelineEvents.GetUsableDirListStarted,
        id,
    } as const);

//利用可能ディレクトリリスト取得完了
export const getUsableDirListComplete = (result: Folder[]) =>
    ({
        type: TimelineEvents.GetUsableDirListComplete,
        result,
    } as const);

// クリップ追加作成
export const AddClipToTimeline = (
    timelineId: number,
    footageId: number,
    start: number,
    end: number,
    seq: number,
    userId: number
) =>
    ({
        type: TimelineEvents.AddClipToTimelineStarted,
        timelineId,
        footageId,
        start,
        end,
        seq,
        userId,
    } as const);

export const AddClipToTimelineComplete = (clipList: Clip[]) =>
    ({
        type: TimelineEvents.AddClipToTimelineComplete,
        clipList,
    } as const);

// クリップ移動
export const ClipMoveStarted = (id: number, seq: number, userId: number) =>
    ({
        type: TimelineEvents.ClipMoveStarted,
        id,
        seq,
        userId,
    } as const);

export const ClipMoveComplete = (clipList: Clip[]) =>
    ({
        type: TimelineEvents.ClipMoveComplete,
        clipList,
    } as const);

// クリップを削除
export const DeleteClip = (id: number, userId: number) =>
    ({
        type: TimelineEvents.DeleteClipStarted,
        id,
        userId,
    } as const);

export const DeleteClipComplete = (clipList: Clip[]) =>
    ({
        type: TimelineEvents.DeleteClipComplete,
        clipList,
    } as const);

//クリップの分割
export const CutClip = (id: number, cutPoint: number, userId: number) =>
    ({
        type: TimelineEvents.CutClipStarted,
        id,
        cutPoint,
        userId,
    } as const);

export const CutClipComplete = (clipList: Clip[]) =>
    ({
        type: TimelineEvents.CutClipComplete,
        clipList,
    } as const);

export const CutClipFailed = (response: any) =>
    ({
        type: TimelineEvents.CutClipFailed,
        response,
    } as const);

export const UpdateTimelineStatus = (id: number, status: string) =>
    ({
        type: TimelineEvents.UpdateTimelineStatus,
        status,
        id,
    } as const);

export const UpdateTimelineStatusCompleted = (timeline: TimelineInfo) =>
    ({
        type: TimelineEvents.UpdateTimelineStatusCompleted,
        timeline,
    } as const);

// クリップの編集
export const EditTimelineClip = (
    deleteClipId: number,
    timelineId: number,
    footageId: number,
    start: number,
    end: number,
    seq: number,
    userId: number
) =>
    ({
        type: TimelineEvents.EditClipStarted,
        deleteClipId,
        timelineId,
        footageId,
        start,
        end,
        seq,
        userId,
    } as const);

export const EditClipComplete = (clipList: Clip[]) =>
    ({
        type: TimelineEvents.EditClipComplete,
        clipList,
    } as const);

// タイライム名変更
export const RenameTimeline = (id: number, name: string, userId: number) =>
    ({
        type: TimelineEvents.RenameTimelineStarted,
        id,
        name,
        userId,
    } as const);

export const RenameTimelineComplete = (timeline: TimelineInfo[]) =>
    ({
        type: TimelineEvents.RenameTimelineComplete,
        timeline,
    } as const);

// タイムライン編集のUNDO、REDO
export const UpdateTimelineClipList = (timelineId: number, userId: number, clipList: Clip[]) =>
    ({
        type: TimelineEvents.UpdateTimelineClipList,
        timelineId,
        userId,
        clipList,
    } as const);

export const UpdateTimelineClipListComplete = (clipList: Clip[]) =>
    ({
        type: TimelineEvents.UpdateTimelineClipListComplete,
        clipList,
    } as const);